/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} App_Slider_Easy_To_UseInputs */

const en_app_slider_easy_to_use = /** @type {(inputs: App_Slider_Easy_To_UseInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Easy to use.`)
};

const es_app_slider_easy_to_use = /** @type {(inputs: App_Slider_Easy_To_UseInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Fácil de usar.`)
};

/**
* | output |
* | --- |
* | "Easy to use." |
*
* @param {App_Slider_Easy_To_UseInputs} inputs
* @param {{ locale?: "en" | "es" }} options
* @returns {LocalizedString}
*/
export const app_slider_easy_to_use = /** @type {((inputs?: App_Slider_Easy_To_UseInputs, options?: { locale?: "en" | "es" }) => LocalizedString) & import('../runtime.js').MessageMetadata<App_Slider_Easy_To_UseInputs, { locale?: "en" | "es" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "es") return es_app_slider_easy_to_use(inputs)
	return en_app_slider_easy_to_use(inputs)
});